import $ from "jquery";

export default function customAccordion() {

        $('.accordion-header:not(.accordion-header-side-nav)').on('click', function() {
            let $accordionItem = $(this).closest('.accordion-item');
            let $accordionCollapse = $accordionItem.find('.accordion-collapse');
            let $accordionButton = $(this).find('.accordion-button');

            $accordionItem.siblings().find('.accordion-collapse.show').slideUp(300).removeClass('show')
                .prev('.accordion-header').find('.accordion-button').addClass('collapsed').attr('aria-expanded', 'false');

            if ($accordionCollapse.hasClass('show')) {
                $accordionCollapse.slideUp(300).removeClass('show');
                $accordionButton.addClass('collapsed').attr('aria-expanded', 'false');
            } else {
                $accordionCollapse.slideDown(300).addClass('show');
                $accordionButton.removeClass('collapsed').attr('aria-expanded', 'true');
            }

            let windowHeight = $(window).height();
            let headerOffset = $(this).offset().top;
            let scrollPosition = headerOffset - (windowHeight / 2) - 100;

            $('html, body').animate({
                scrollTop: scrollPosition
            }, 0);
        });


}
